import React, { useEffect, useState } from "react";
import CardComponent from "../cardComponents/CardComponent";
import AccordionComponent from "../accordion/AccordionComponent";
// import { CreditCardData } from './CardData'
import Http from "../../Http";
import { CARD_API } from "../../Helper";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import { motion } from "framer-motion";
import {
  FaTags,
  FaRegCheckCircle,
  FaArrowRight,
  FaFileAlt,
  FaUpload,
} from "react-icons/fa";
import FAQSchema from "../../FAQSchema";
import { BadgeCheck, FileText } from "lucide-react";
const HDFC = () => {
  const [CreditCardData, setCreditCardData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [cardsPerPage] = useState(10);
  const [activeIndex, setActiveIndex] = useState(0);

  const toggleAccordion = (index) => {
    if (activeIndex === index) {
      // If the clicked question is already expanded, collapse it
      setActiveIndex(null);
    } else {
      // If the clicked question is not expanded, expand it
      setActiveIndex(index);
    }
  };
  function Icon({ id, open }) {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={2}
        stroke="currentColor"
        className={`${
          id === open ? "rotate-180" : ""
        } h-5 w-5 transition-transform`}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M19.5 8.25l-7.5 7.5-7.5-7.5"
        />
      </svg>
    );
  }

  useEffect(() => {
    Http.post(CARD_API)
      .then((res) => {
        setCreditCardData(res);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  const indexOfLastCard = currentPage * cardsPerPage;
  const indexOfFirstCard = indexOfLastCard - cardsPerPage;
  console.log({ indexOfLastCard, indexOfFirstCard });
  // const currentCards = CreditCardData.cards
  //   ?.filter((card) => card.category === "Credit card")
  //   .slice(indexOfFirstCard, indexOfLastCard);
  // console.log({ currentCards });
  const currentCards = CreditCardData.cards
  ?.filter((card) => card.title?.toLowerCase().includes("hdfc"))
  .slice(indexOfFirstCard, indexOfLastCard);
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const faqs = [
    {
      question: "What types of credit cards does HDFC Bank offer?",
      answer:
        "   HDFC offers a wide range of cards, including cashback (Millennia), travel (Regalia, Diners ClubMiles), fuel (IndianOil HDFC Card), and premium lifestyle cards (Infinia, Diners Club Black).",
    },
    {
      question:
        "Is there a lifetime free credit card option available from HDFC?",
      answer:
        "  Yes, select HDFC cards come with lifetime free benefits either by default or upon achieving annual spending milestones. Terms vary across card variants.",
    },
    {
      question:
        "How long does it take for the HDFC credit card application to process?",
      answer:
        " Online applications are typically processed within 3–5 working days, and physical cards are delivered within 7–10 days post-approval.",
    },
    {
      question: "What is the annual fee range for HDFC credit cards?",
      answer:
        "   Annual fees range from ₹500 for entry-level cards to ₹10,000 for premium cards like Infinia. Many cards offer fee waivers on meeting annual spend criteria.",
    },
    {
      question: " Can I track my HDFC credit card application status?",
      answer:
        "   Yes, you can track your application status on the official HDFC Bank website using your mobile number, application reference number, or date of birth.",
    },
  ];

  const steps = [
    {
      icon: <FaTags className="h-6 w-6 text-orange-500" />,
      title: "Collect Required Documents",
      description:
        " Have your identity, address, and income documents ready for a hassle-free application experience.",
    },
    {
      icon: <FaRegCheckCircle className="h-6 w-6 text-green-500" />,
      title: "Check Eligibility Requirements",
      description:
        " Make sure you meet the age, income, and credit score criteria mentioned for the specific HDFC card you’re interested in.",
    },
    {
      icon: <FaArrowRight className="h-6 w-6 text-purple-600" />,
      title: "Redirect to HDFC Bank’s Official Website",
      description:
        "Once you've chosen a suitable card, click “Apply Now” to be securely redirected to SBI Card’s official website, where you can complete the application process.",
    },
    {
      icon: <FaFileAlt className="h-6 w-6 text-teal-500" />,
      title: "Explore & Compare with TheFinMaster",
      description:
        "Browse through our handpicked selection of HDFC Bank credit cards on TheFinMaster. Each listing includes detailed features, reward structures, joining/annual fees, and user suitability—making it easy to compare and choose what fits your financial lifestyle best.",
    },
  ];
  return (
    <>
      <Helmet>
        <title>
          Get HDFC Credit Cards in 2024: Apply Online | Check Offers |
          TheFinmaster
        </title>
        <meta
          name="description"
          content="Compare and apply HDFC cards online, select the best among lifestyle, travel, shopping credit card and explore the features, benefits, eligibility, charges and offers. | TheFinmaster"
        />
        <meta
          name="keywords"
          content="hdfc credit card payment, hdfc credit card offers, hdfc bank lifetime free credit card, my hdfc credit card, hdfc millennia credit card, hdfc credit card payment online, hdfc bank credit card internet banking"
        />
        <link
          rel="canonical"
          href="https://thefinmaster.com/hdfc-bank/credit-card"
        />
        <meta
          name="robots"
          content="max-snippet:-1, max-image-preview:standard"
        />
        <meta name="robots" content="max-video-preview:-1" />
      </Helmet>

      <FAQSchema faqs={faqs} />
      <div className="w-full flex flex-col items-center ">
        <div className="w-full flex flex-col items-center ">
          <div className=" mt-10 w-full flex flex-col items-center justify-center bg-black h-[200px] md:h-[300px] shadow-lg mb-5 border-b-8 border-blue-600">
            <h1 className="text-white text-4xl md:text-7xl text-center font-medium">
              Credit Card
            </h1>
            <p className="text-gray-200 text-lg md:text-2xl pt-2 px-4 text-center">
              Experience financial freedom and flexibility with our credit card
              options.
            </p>
          </div>
        </div>
        {/* <div className='text-center'>
        <p className='text-gray-600 text-2xl pt-2 md:text-xl md:px-10'>
        While building any interface, you are faced with a dozen decisions
    every minute. At the core of every high quality interface, is a
    set of constraints that help in creating this level of consistency
    and quality.  While building any interface, you are faced with a dozen decisions
    every minute. At the core of every high quality interface, is a
    set of constraints that help in creating this level of consistency
    and quality.  
        </p>
    </div> */}
     <div className="flex justify-center items-center  p-4 mt-10">
          <div className="bg-white shadow-lg rounded-2xl p-6 max-w-7xl text-center mt-4">
            <h2 className="text-3xl font-bold text-gray-800 mb-4">
              Explore HDFC Bank’s Versatile & Rewarding Credit Card Collection
            </h2>

            <p className="text-gray-600 leading-relaxed mt-3">
              HDFC Bank, a leading private sector bank in India, offers one of
              the most comprehensive portfolios of credit cards tailored for
              shopping, travel, fuel, dining, premium lifestyles, and business
              needs. Whether you’re a frequent flyer or a smart spender, HDFC
              cards deliver unmatched value through exclusive benefits,
              cashback, and reward programs.
            </p>
          </div>
        </div>
        <h1 className="text-3xl font-bold text-gray-800 my-10">
          Featured Credit Cards
        </h1>
        <div className="w-[95%] mx-auto flex gap-5 flex-wrap md:flex-nowrap justify-center mb-10">
          <div className="w-fit flex flex-col gap-8">
            {currentCards &&
              currentCards.map((item, index) => {
                return (
                  <>
                    {" "}
                    <CardComponent
                       key={index}
                       cardDetails={item}
                       Card_features={item?.Card_features}
                       fees={item?.fees}
                       cardName={item?.title}
                       cardImage={item?.image}
                       rating={item?.rating}
                       category={item?.category}
                       status={item?.status}
                       bank_link={item?.bank_link}
                    />{" "}
                  </>
                );
              })}
          </div>

            <div className="w-full relative ">
                     <div className="sticky overflow-hidden top-20 w-full h-[500px] flex flex-col justify-between">
                       {/* <div className="w-[70%] mx-auto">
                                                  <h2 className="text-center font-medium pt-5 text-lg">
                                                    <span className="font-semibold text-white">816 people</span>{" "}
                                                    are on call with our advisors right now
                                                  </h2>
                                                </div> */}
                       <div className="w-full mx-auto">
                         <Link
                           to="https://play.google.com/store/apps/details?id=com.popclub.android&pcampaignid=web_share"
                           target="_blank"
                           rel="noopener noreferrer"
                         >
                           <div className="w-[80%] mx-auto ">
                             <img src="/assets/ppp.png" alt="Advertisement" />
                           </div>
                         </Link>
                         <div className="bg-white">
                           {/* <h3 className="text-center text-blue-500 cursor-pointer font-semibold py-2">
                                                      Know your advisor
                                                    </h3> */}
                         </div>
                       </div>
                     </div>
                   </div>
                 </div>
        {/* Pagination */}
        <ul className="flex justify-center mt-4">
          {currentCards &&
            CreditCardData.cards?.filter(
              (card) => card.category === "Credit card"
            ).length > 0 &&
            Math.ceil(
              CreditCardData.cards?.filter(
                (card) => card.category === "Credit card"
              ).length / cardsPerPage
            ) > 1 &&
            Array.from({
              length: Math.ceil(
                CreditCardData.cards?.filter(
                  (card) => card.category === "Credit card"
                ).length / cardsPerPage
              ),
            }).map((_, index) => (
              <li key={index} className="mx-1">
                <button
                  className={`px-3 py-1 rounded-lg ${
                    currentPage === index + 1
                      ? "bg-blue-500 text-white"
                      : "bg-gray-200 text-gray-800"
                  }`}
                  onClick={() => paginate(index + 1)}
                >
                  {index + 1}
                </button>
              </li>
            ))}
        </ul>

       

        {/* <div className='w-[95%] py-10'>
                <h1 className='text-center font-bold text-5xl my-10'>Frequently Asked Questions</h1>
                <AccordionComponent />
            </div> */}

        <div className="w-full px-2 py-10 bg-gradient-to-br from-sky-50 via-white to-sky-100 dark:from-gray-900 dark:to-gray-800">
          <div className="max-w-6xl mx-auto grid gap-10">
            <div className="bg-white dark:bg-gray-900 rounded-2xl shadow-lg p-6 md:p-10 border border-sky-200 dark:border-gray-700 hover:shadow-xl transition-shadow">
              <div className="flex items-center gap-3 mb-6">
                <FileText className="w-8 h-8 text-sky-600" />
                <span className="text-3xl font-bold text-gray-800 dark:text-white">
                  Eligibility Criteria to Apply for HDFC Credit Card
                </span>
              </div>
              <div className="grid sm:grid-cols-2 gap-6 text-gray-700 dark:text-gray-300">
                <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Geographic Location
                  </span>
                  <span>
                    {" "}
                    Applicants must be Indian residents with a permanent address
                    located in cities or towns serviced by HDFC Bank’s credit
                    card division.
                  </span>
                </div>

                <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Credit Score Requirement
                  </span>
                  <span>
                    {" "}
                    A minimum CIBIL score of 700 is preferred. Higher scores
                    improve approval chances and may also help negotiate better
                    credit limits.
                  </span>
                </div>
                <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Occupation Type
                  </span>
                  <span>
                    {" "}
                    Both salaried and self-employed applicants are eligible.
                    HDFC Bank assesses income proof, employment stability, and
                    business continuity accordingly.
                  </span>
                </div>
                <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Minimum Age Requirement
                  </span>
                  <span>
                    {" "}
                    The primary cardholder must be between 21 to 60 years of
                    age. Add-on cardholders should be at least 18 years old.
                    This ensures maturity in handling credit responsibly.
                  </span>
                </div>
                <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Income Criteria
                  </span>
                  <span>
                    {" "}
                    Salaried individuals should typically have a monthly income
                    of ₹25,000 or more, while self-employed individuals should
                    have an annual ITR of ₹6 lakhs or above. Premium cards like
                    HDFC Infinia or Diners Club Black may require higher income
                    levels.
                  </span>
                </div>
              </div>
            </div>

            <div className="bg-white dark:bg-gray-900 rounded-2xl shadow-lg p-6 md:p-10 border border-emerald-200 dark:border-gray-700 hover:shadow-xl transition-shadow">
              <div className="flex items-center gap-3 mb-6">
                <BadgeCheck className="w-8 h-8 text-emerald-600" />
                <span className="text-3xl font-bold text-gray-800 dark:text-white">
                  Documents Required to Apply for HDFC Credit Card
                </span>
              </div>
              <div className="grid sm:grid-cols-2 gap-6 text-gray-700 dark:text-gray-300">
                <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Proof of Identity
                  </span>
                  <span>
                    {" "}
                    Any government-issued document such as Aadhaar Card, PAN
                    Card, Passport, or Driving License is accepted to verify
                    personal identity.
                  </span>
                </div>
                <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Proof of Address
                  </span>
                  <span>
                    {" "}
                    Valid residential address proof includes Aadhaar, utility
                    bills (not older than 3 months), or a rental agreement. This
                    helps establish your address for communication and delivery.
                  </span>
                </div>
                <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Income Proof
                  </span>
                  <span>
                    {" "}
                    Salaried: Last 3 months' salary slips and latest Form 16.
                    Self-employed: Latest two years' ITR and audited financials
                    These help the bank gauge your financial stability and
                    repayment capacity.{" "}
                  </span>
                </div>
                <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                  Recent Passport-size Photograph
                  </span>
                  <span>
                    {" "}
                    A clear, recent photograph is required for documentation and KYC compliance.
                  </span>
                </div>
                <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl sm:col-span-2">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Pan Card
                  </span>
                  <span>
                    {" "}
                    Mandatory for all credit card applications. It helps link your financial records and allows the bank to verify your tax status.
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="px-4 py-10 md:px-8 max-w-7xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold text-gray-800 text-center mb-4">
        How to Apply for HDFC Bank Credit Card
        </h2>
        {/* <p className="text-gray-600 text-sm md:text-base mt-2 text-center mb-8">
          Applying for a fuel credit card is a seamless process that starts with
          the right research and ends at the official bank’s platform for final
          submission. Here’s how you can get started through TheFinMaster.com:
        </p> */}
        <div className="grid gap-6 md:grid-cols-2">
          {steps.map((step, index) => (
            <motion.div
              key={index}
              className="flex items-start gap-4 p-4 rounded-xl bg-white dark:bg-gray-900 shadow-md border hover:shadow-lg transition"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: index * 0.1 }}
              viewport={{ once: true }}
            >
              <div className="mt-1">{step.icon}</div>
              <div>
                <h3 className="text-lg font-semibold text-gray-800 dark:text-white mb-1">{`${
                  index + 1
                }. ${step.title}`}</h3>
                <p className="text-md text-gray-600 dark:text-gray-300">
                  {step.description}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
      <div className="max-w-4xl mx-auto py-6 px-2">
        <h1 className="text-2xl md:text-3xl font-semibold text-center mb-8">
          Frequently Asked Questions
        </h1>
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="border rounded-lg overflow-hidden shadow-md"
            >
              <button
                onClick={() => toggleAccordion(index)}
                className="w-full p-4 text-left text-lg font-semibold focus:outline-none flex justify-between items-center"
              >
                {faq.question}
                <Icon id={index} open={activeIndex} />
              </button>
              {activeIndex === index && (
                <div className="p-4 bg-gray-100">
                  <p className="text-gray-700">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default HDFC;
